module.exports = __webpack_public_path__ + "img/man1.52e4cc1d.jpg";